namespace GeniuzPOS.PosShift {
    export interface ReportSaleTaxForm {
        DocDate: Serenity.DateEditor;
        PosId: Serenity.StringEditor;
        PosPermitNo: Serenity.StringEditor;
        DocType: Serenity.IntegerEditor;
        StartDocNo: Serenity.StringEditor;
        EndDocNo: Serenity.StringEditor;
        NonVatAmt: Serenity.DecimalEditor;
        ExVatAmt: Serenity.DecimalEditor;
        VatAmt: Serenity.DecimalEditor;
        TotalAmt: Serenity.DecimalEditor;
    }

    export class ReportSaleTaxForm extends Serenity.PrefixedContext {
        static formKey = 'PosShift.ReportSaleTax';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!ReportSaleTaxForm.init)  {
                ReportSaleTaxForm.init = true;

                var s = Serenity;
                var w0 = s.DateEditor;
                var w1 = s.StringEditor;
                var w2 = s.IntegerEditor;
                var w3 = s.DecimalEditor;

                Q.initFormType(ReportSaleTaxForm, [
                    'DocDate', w0,
                    'PosId', w1,
                    'PosPermitNo', w1,
                    'DocType', w2,
                    'StartDocNo', w1,
                    'EndDocNo', w1,
                    'NonVatAmt', w3,
                    'ExVatAmt', w3,
                    'VatAmt', w3,
                    'TotalAmt', w3
                ]);
            }
        }
    }
}
